var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":24,"height":24,"viewBox":`0 0 24 24`,"aria-labelledby":_vm.name}},[_c('title',{attrs:{"id":_vm.name,"lang":"en"}},[_vm._v(_vm._s(_vm.name)+" icon")]),_c('g',{domProps:{"innerHTML":_vm._s(_vm.Icons[_vm.name])}})])
}
var staticRenderFns = []

export { render, staticRenderFns }